import React, {useEffect, useState} from "react";

const PaymentDeclined = () => {
    const [orderId, setOrderId] = useState("");
    const [msg, setMsg] = useState("");

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        setOrderId(urlSearchParams.get("order"));
        setMsg(urlSearchParams.get("msg"));
    }, []);
  const handleBack = () => {
    window.close();
  };


  const centerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
  };

  return (
              <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: 'calc(100vh - 76px)' }}>
                  <div className="card border-0 shadow-lg rounded-4 overflow-hidden mb-4">
                      <div className="card-header bg-white border-0 py-3 px-4 fw-bold text-dark fs-5">Order Number: {orderId}</div>
                      <div className="card-body">
                          <div className="d-flex container">
                              <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: 'calc(100vh - 76px)' }}>
                                  <span>Status: Declined. <br/>Reason: {msg}</span><br/>
                              </div>
                              <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: 'calc(100vh - 76px)' }}>
                                  <div className="d-flex justify-content-center mt-3">
                                      <button className="btn btn-secondary" style={centerStyle} onClick={handleBack}>Back</button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
  );
};

export default PaymentDeclined;
